import React from 'react';
import "./Log.css";
import Streak from './Streak';

const logPositions = [
  { bottom: "100px", left: "100px", rotate: "150deg", scaleX: "0.75", zIndex: "20" },
  { bottom: "120px", left: "140px", rotate: "110deg", scaleX: "0.75", zIndex: "10" },
  { bottom: "98px", left: "68px", rotate: "-10deg", scaleX: "0.75", zIndex: "inherit" },
  { bottom: "80px", left: "220px", rotate: "-120deg", scaleX: "0.75", zIndex: "26" },
  { bottom: "75px", left: "210px", rotate: "-30deg", scaleX: "0.75", zIndex: "25" },
  { bottom: "92px", left: "280px", rotate: "35deg", scaleX: "0.85", zIndex: "30" },
  { bottom: "70px", left: "300px", rotate: "-30deg", scaleX: "0.75", zIndex: "20" },
];

interface LogProps {
  index: number;
}

export default function Log({ index }: LogProps) {
  const { bottom, left, rotate, scaleX, zIndex } = logPositions[index];

  return (
    <div
      className="log absolute overflow-hidden"
      style={{
        width: "238px",
        height: "70px",
        bottom: bottom,
        borderRadius: "32px",
        background: "#781e20",
        left: left,
        transform: `rotate(${rotate}) scaleX(${scaleX})`,
        transformOrigin: "center center",
        zIndex: zIndex,
        opacity: "0.99",
      }}
    >
      {[...Array(10)].map((_, i) => (
        <Streak index={i} key={i} />
      ))}
    </div>
  );
}